webpackJsonp([115665932196808],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InvisibleSpan = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px 1px 1px 1px);\n    /* IE6, IE7 */\n    clip: rect(1px, 1px, 1px, 1px);\n'], ['\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px 1px 1px 1px);\n    /* IE6, IE7 */\n    clip: rect(1px, 1px, 1px, 1px);\n']);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InvisibleSpan = exports.InvisibleSpan = _styledComponents2.default.span(_templateObject);

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  z-index: 1;\n\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: ', ';  \n'], ['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  z-index: 1;\n\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: ', ';  \n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n\n  label {\n    display: inline-block;\n\n    padding-top: ', ';\n    padding-bottom: ', ';\n    padding-right: 0;\n    padding-left: 0;\n    margin: 0;\n\n    select {\n      padding-top: ', ';\n      padding-bottom: ', ';\n      padding-left: ', ';\n      padding-right: ', ';\n  \n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: ', ';\n      margin-right: 0;\n\n      border-radius: 0.2rem;\n    }\n  }\n\n  label:last-child {\n    padding-left: ', ';\n  }\n'], ['\n  text-align: center;\n\n  label {\n    display: inline-block;\n\n    padding-top: ', ';\n    padding-bottom: ', ';\n    padding-right: 0;\n    padding-left: 0;\n    margin: 0;\n\n    select {\n      padding-top: ', ';\n      padding-bottom: ', ';\n      padding-left: ', ';\n      padding-right: ', ';\n  \n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: ', ';\n      margin-right: 0;\n\n      border-radius: 0.2rem;\n    }\n  }\n\n  label:last-child {\n    padding-left: ', ';\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	var _Technologies = __webpack_require__(63);
	
	var _Technologies2 = _interopRequireDefault(_Technologies);
	
	var _Invisible = __webpack_require__(25);
	
	var _Select = __webpack_require__(129);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _ramda = __webpack_require__(11);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var getUniqList = function getUniqList(technologies, prop) {
	  return (0, _ramda.uniq)(technologies.reduce(function (years, tech) {
	    return years.concat(tech[prop]);
	  }, []));
	};
	
	var filterTechBy = function filterTechBy(prop, value) {
	  return function (technologies) {
	    return value === '' ? technologies : technologies.filter(function (t) {
	      return (0, _ramda.contains)(value, t[prop]);
	    });
	  };
	};
	
	var Filters = _styledComponents2.default.fieldset(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.colors.blackShades[0];
	});
	
	var Selects = _styledComponents2.default.div(_templateObject2, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(-1);
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(0);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(-6);
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(-4);
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.scale(-6);
	}, function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.scale(-4);
	}, function (_ref8) {
	  var theme = _ref8.theme;
	  return theme.scale(-6);
	}, function (_ref9) {
	  var theme = _ref9.theme;
	  return theme.scale(-1);
	});
	
	var TechnologiesPage = function (_React$PureComponent) {
	  _inherits(TechnologiesPage, _React$PureComponent);
	
	  function TechnologiesPage(props) {
	    _classCallCheck(this, TechnologiesPage);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.selectYear = function (year) {
	      _this.setState({
	        selectedYear: year
	      });
	    };
	
	    _this.selectTag = function (tag) {
	      _this.setState({
	        selectedTag: tag
	      });
	    };
	
	    _this.getTechnologies = function () {
	      return (0, _ramda.pipe)(filterTechBy('years', _this.state.selectedYear), filterTechBy('tags', _this.state.selectedTag))(_this.technologies);
	    };
	
	    _this.technologies = props.data.site.siteMetadata.resume.technologies;
	
	    _this.years = getUniqList(_this.technologies, 'years');
	    _this.tags = getUniqList(_this.technologies, 'tags');
	
	    _this.state = {
	      selectedYear: (0, _ramda.head)(_this.years),
	      selectedTag: ''
	    };
	    return _this;
	  }
	
	  TechnologiesPage.prototype.render = function render() {
	    var years = (0, _Select.addAll)((0, _Select.getItemsFromArray)(this.years, this.state.selectedYear));
	    var tags = (0, _Select.addAll)((0, _Select.getItemsFromArray)(this.tags, this.state.selectedTag));
	    var technologies = this.getTechnologies();
	    var menu = this.props.data.site.siteMetadata.resume.menu;
	
	
	    return _react2.default.createElement(
	      _ResumeContainer2.default,
	      {
	        menu: menu,
	        selectedPage: '/resume/'
	      },
	      _react2.default.createElement(
	        Filters,
	        null,
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'resume.technologies' },
	          function (txt) {
	            return _react2.default.createElement(
	              'legend',
	              null,
	              _react2.default.createElement(_reactHelmet2.default, {
	                title: txt,
	                meta: [{ name: 'description', content: txt }]
	              }),
	              _react2.default.createElement(
	                _Invisible.InvisibleSpan,
	                null,
	                txt
	              )
	            );
	          }
	        ),
	        _react2.default.createElement(
	          Selects,
	          null,
	          _react2.default.createElement(_Select2.default, {
	            items: years,
	            onChange: this.selectYear,
	            selected: this.state.selectedYear,
	            label: 'resume.filters.year'
	          }),
	          _react2.default.createElement(_Select2.default, {
	            items: tags,
	            onChange: this.selectTag,
	            selected: this.state.selectedTag,
	            label: 'resume.filters.tag'
	          })
	        )
	      ),
	      _react2.default.createElement(_Technologies2.default, { technologies: technologies })
	    );
	  };
	
	  return TechnologiesPage;
	}(_react2.default.PureComponent);
	
	TechnologiesPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = TechnologiesPage;
	module.exports = exports['default'];

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.addAll = exports.getItemsFromArray = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import styled from 'styled-components';
	
	
	var getItemsFromArray = exports.getItemsFromArray = function getItemsFromArray(items) {
	  return items.map(function (i) {
	    return {
	      label: i,
	      value: i
	    };
	  });
	};
	
	var addAll = exports.addAll = function addAll(items) {
	  return [{
	    label: 'all',
	    value: ''
	  }].concat(items);
	};
	
	var Select = function (_React$PureComponent) {
	  _inherits(Select, _React$PureComponent);
	
	  function Select() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Select);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onChange = function (event) {
	      _this.props.onChange(event.target.value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Select.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        items = _props.items,
	        selected = _props.selected;
	
	    return _react2.default.createElement(
	      'label',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: label }),
	      _react2.default.createElement(
	        'select',
	        { value: selected, onChange: this.onChange },
	        items.map(function (item, i) {
	          return _react2.default.createElement(
	            'option',
	            { key: i, value: item.value },
	            item.label
	          );
	        })
	      )
	    );
	  };
	
	  return Select;
	}(_react2.default.PureComponent);
	
	Select.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any.isRequired,
	    label: _propTypes2.default.string.isRequired
	  })).isRequired,
	  selected: _propTypes2.default.any,
	  label: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func
	};
	
	exports.default = Select;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TechnologiesPage = __webpack_require__(128);
	
	var _TechnologiesPage2 = _interopRequireDefault(_TechnologiesPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_TechnologiesPage2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-index-fr-js-8cb7a23b09d0fa0c1a9c.js